import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation RegulationStrategyDelete($uid: String!){
        regulation_strategy_delete (uid: $uid) {
            success
        }
    }
`;

export async function regulationStrategyDelete(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ regulation_strategy_delete: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.regulation_strategy_delete;
}
